import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LoadingSpinner from "./LoadingSpinner/LoadingSpinner";
import "./loading.css";

function Loading() {
  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center min-vh-100"
    >
      <Row className="align-items-center">
        <Col className="text-center align-items-center">
          <LoadingSpinner size={112} />
        </Col>
      </Row>
    </Container>
  );
}

export default Loading;
